import {
  Button,
  Icon,
  IconProps,
  Menu as ChakraMenu,
  MenuButton,
  MenuButtonProps,
  MenuItem,
  MenuList,
  MenuListProps,
  PlacementWithLogical,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { SVGProps } from 'react';
import { KText } from '@/ui-library/components/text';
interface MenuItemType {
  id: string | number;
  label?: string;
  Comp?: React.ComponentType<any>;
  // @ts-ignore
  icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  iconProps?: IconProps;
  onClick?: Function;
}

interface MenuProps {
  menuItems: MenuItemType[];
  handleActionClick?: Function;
  menuButtonLabel: string;
  // @ts-ignore
  leftIcon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  leftIconProps?: IconProps;
  placement?: PlacementWithLogical;
  menuButtonProps?: MenuButtonProps;
  testId?: string;
  menulistProps?: MenuListProps;
}

export const Menu = ({
  menuItems,
  handleActionClick,
  leftIcon,
  menuButtonLabel,
  placement,
  menuButtonProps,
  testId = 'more-options',
  menulistProps,
}: MenuProps) => {
  return (
    <ChakraMenu placement={placement}>
      <MenuButton
        as={Button}
        leftIcon={leftIcon && <Icon as={leftIcon} color="ats-primary" />}
        rightIcon={<Icon width={'16px'} height="unset" as={ChevronDownIcon} />}
        variant="secondary"
        maxH="34px"
        px="12px"
        boxShadow="0px 1px 2px 0px #1018280D"
        data-test-id={`menu-button-${testId}`}
        {...menuButtonProps}
      >
        {menuButtonLabel}
      </MenuButton>
      <MenuList zIndex="5" {...menulistProps}>
        {menuItems?.map((item) => {
          const { iconProps, id, label, icon, onClick, Comp } = item;
          return (
            <MenuItem
              key={id}
              gap="8px"
              onClick={() => {
                onClick?.(item);
                handleActionClick?.(item);
              }}
            >
              {Comp ? (
                <Comp />
              ) : (
                <>
                  {icon && (
                    <Icon
                      as={icon}
                      width="16px"
                      height="16px"
                      color="primary-900"
                      className="primary-900"
                      {...iconProps}
                    />
                  )}
                  <KText size="sm-medium" data-test-id={`menu-item-${id}`}>
                    {label}
                  </KText>
                </>
              )}
            </MenuItem>
          );
        })}
      </MenuList>
    </ChakraMenu>
  );
};
